import { ICrmCompanyProfile, ICrmContactProfile } from "services/CrmApi/types/DirectoryEntry";
import { formatDateTimeDisplayWithoutOffset } from "utils";
import qs from 'qs';

export const isCompanyProfile = (profile: ICrmCompanyProfile | ICrmContactProfile): profile is ICrmCompanyProfile => {
  return 'companyType' in profile;
};

export const isContactProfile = (profile: ICrmCompanyProfile | ICrmContactProfile): profile is ICrmContactProfile => {
  return 'contactType' in profile;
};

export const getCurrentDateAndTime = () => {
  const now = new Date();
  const date = formatDateTimeDisplayWithoutOffset(now);
  const time = now.toLocaleTimeString(undefined, {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false, // Use 24-hour format
  });
  
  return { date, time };
}

export const getReferencedActivityIdFromUrl = () => {
  const search = (window.location.search || '').replace('?', '');
  const queryObj = qs.parse(search);
  const referencedActivityId = queryObj.key;
  return referencedActivityId;
}

export const removeActivityIdFromUrl = () => {
  const url = new URL(window.location.href);
  url.search = '';
  window.history.pushState({}, '', url.toString());
}
